module.exports = __webpack_public_path__ + "static/img/Cooperation_2.3c41ae2c.jpg";